import router from '../router'

const navBars = {
  'document-selection': ['module-material-types']
}

const state = {
  routes: []
}

const actions = {}

const mutations = {
  changedRoute (state, route) {
    // Resolve nav bar content for current route
    if (typeof navBars[route.name] !== 'undefined') {
      const routes = navBars[route.name]
      state.routes = router.options.routes.filter(route => routes.includes(route.name))
    } else {
      state.routes = []
    }
  }
}

export const navigation = {
  namespaced: true,
  state,
  actions,
  mutations
}
